export const PERSON_LAYOUT = {
  widthPct: 0.28,
  heightPct: 0.42,
  centerXPct: 0.5,
  bottomPct: 0.02,
} as const

export interface CompositeRect {
  left: number
  top: number
  width: number
  height: number
}

/** Single layout owner for person video + skeleton alignment */
export function computePersonRect(
  viewportW: number,
  viewportH: number,
  layout = PERSON_LAYOUT,
): CompositeRect {
  const width = viewportW * layout.widthPct
  const height = viewportH * layout.heightPct
  const left = viewportW * layout.centerXPct - width / 2
  const top = viewportH - height - viewportH * layout.bottomPct
  return { left, top, width, height }
}

export const Z_STACK = {
  canvas: 0,
  person: 10,
  skeleton: 15,
  ui: 20,
  modal: 30,
} as const
